import { FC, PropsWithChildren } from 'react';
import { cx } from '@emotion/css';

import { Image } from '@phoenix/team-m/dashboard/frontend/shared/components/image';
import { PlaceholderImage } from '@phoenix/core/frontend/shared/ui/images/placeholder-image';
import { imageDomains } from '@phoenix/team-m/my-tool-shed/frontend/domain/security/csp';

interface ProductImageProps extends PropsWithChildren {
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
  placeholderImgClassName?: string;
  sizes?: string;
}

export const ProductImage: FC<ProductImageProps> = ({
  imageSrc,
  imageAlt = 'Product image',
  className,
  placeholderImgClassName,
  sizes,
}) => {
  const isAllowed = () => {
    try {
      const domain = new URL(imageSrc ?? '');
      return imageDomains.includes(`https://${domain.hostname}`);
    } catch {
      return false;
    }
  };

  return imageSrc && isAllowed() ? (
    <div className={cx(className, 'picture relative w-full')} data-testid="productImage">
      <Image src={imageSrc} fill priority={true} className="object-contain" alt={imageAlt} sizes={sizes} />
    </div>
  ) : (
    <div
      className={cx(className, 'picture flex items-center justify-center self-center bg-secondary-light opacity-50')}
      data-testid="productImagePlaceholder"
    >
      <PlaceholderImage className={cx(placeholderImgClassName, 'text-secondary')} />
    </div>
  );
};
